import { ResponseNode } from '../../core/models/response-node.model';
import { Deserializable } from './deserializable.model';

export class Tag implements Deserializable {
  id: string;
  attributes: {
    id: string;
    name: string;
  };

  deserialize(input: object, included?: Map<string, ResponseNode>): this {
    return Object.assign(this, input);
  }
}
